import React, { useEffect, useMemo, useState } from 'react';
import {Grid,Skeleton} from '@mui/material'
import Layout from './pages/Home/layout/Layout';
import Home from './pages/Home/Home'
import Dashboard from './pages/Dashboard/Dashboard';

import { useServer } from '../../context/ServerContext';
import { getCenters, getData } from './services/api';
import useAssistantViewContext from "../../features/ai-assistant/useAssistantViewContext";
import { buildAssistantViewContext } from "../../features/ai-assistant/documentationKeyResolver";
const  SWVersion = 'v2026.06.24'

const MainNanooxBolt = ({ translate, idioma }) => {
  const { servidor } = useServer();
  const [data, setData] = useState({});
  const [centers, setCenters] = useState([]);
  const [showDashboard, setShowDashboard] = useState(false);
  const [selectedCentro, setSelectedCentro] = useState(localStorage.getItem('CENTRO'));
  const [initialLoading, setInitialLoading] = useState(true); // solo al cambiar centro
  const [refreshing, setRefreshing] = useState(false);       // polling silencioso

  const assistantViewContext = useMemo(
    () => buildAssistantViewContext({
      service: "flux",
      module: showDashboard ? "dashboard" : "general",
      view: "overview",
      entities: {
        region: localStorage.getItem("REGION") || "",
        area: localStorage.getItem("AREA") || "",
        centro: selectedCentro || localStorage.getItem("CENTRO") || "",
      },
      filters: {},
      uiState: {
        showDashboard,
        refreshing,
        initialLoading,
      },
    }),
    [initialLoading, refreshing, selectedCentro, showDashboard]
  );

  useAssistantViewContext(assistantViewContext);

  const cambioVista = () => {
    setShowDashboard(!showDashboard)
  }
  
  // Obtener centros
  useEffect(() => {
    const fetchCenters = async () => {
      try {
        const data = await getCenters(servidor, {
        });
        setCenters(data);
      } catch (e) {
        // manejo de error si es necesario
      } finally {
        // setLoading(false);
      }
    };

    fetchCenters();
  }, []);

  useEffect(() => {
    if (!selectedCentro) return;

    let intervalId;
    let isFetching = false;

    const fetchData = async (isInitial = false) => {
      if (isFetching) return;
      isFetching = true;

      if (isInitial) setInitialLoading(true);
      else setRefreshing(true);

      try {
        const data = await getData(servidor, {
          centro: selectedCentro,
        });
        setData(data);
      } catch (e) {
        console.error(e);
      } finally {
        if (isInitial) setInitialLoading(false);
        else setRefreshing(false);

        isFetching = false;
      }
    };

    // cuando cambia el centro
    fetchData(true);

    // polling sin romper la UI
    intervalId = setInterval(() => fetchData(false), 60_000);

    return () => clearInterval(intervalId);
  }, [servidor, selectedCentro]);


  const PropsLayout = {
    translate,
    idioma,
    servidor,
    SWVersion,
    hora: data?.hora || '',
    barcos:centers,
    cambioVista,
    selectedCentro,
    setSelectedCentro,

  }

  
  return (
    <Grid
        sx={{
          minHeight: '100vh',
          minWidth:'100vw',
          display: 'flex',
          flexDirection: 'column',
        }}
      >
        <Layout {...PropsLayout}>
          {initialLoading ? (
            <HomeSkeleton />
          ) : showDashboard ? (
            <Dashboard servidor={servidor} active={showDashboard} translate={translate} />
          ) : (
            <Home
              data={data}
              center={selectedCentro}
              refreshing={refreshing}
              translate={translate}
            />
          )}
        </Layout>


      </Grid>
  )
}

export default MainNanooxBolt



const HomeSkeleton = () => (
  <Grid container justifyContent={'center'} alignContent={'center'} alignItems={'center'} width='100%' height='100%'  >
      <Skeleton variant="rectangular" width={'60vw'} height={'60vh'} />
  </Grid>
);
